import React from 'react';
import { Button } from '@blueprintjs/core';
import { processType } from 'constants/process-type';
import { ShowIf } from 'components/utils';

class InPhieu extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      arrPrint: []
    }
  }

  render() {

    return (
      <div className="ml5 mr5">
        <ShowIf condition={this.props.huongXuLy == processType.xuLyDon.huongXuLy.deXuatThuLy}>
          {
            (this.props.loaiDonGiaTri != 'DON_KHIEU_NAI' && this.props.loaiDonGiaTri != 'DON_TO_CAO') &&
            <Button type="button" className="btn-green-no-bd tt tt-print" onClick={this.props.inPhieu.bind(this, "THU_LY")}>Tải phiếu đề xuất thụ lý</Button>
          }
          <ShowIf condition={this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO'}>
            <Button type="button" className="btn-green-no-bd tt tt-print" onClick={this.props.inPhieu.bind(this, "DU_THAO_THONG_BAO_THU_LY")}>Tải dự thảo thông báo thụ lý</Button>
          </ShowIf>
          <ShowIf condition={(this.props.loaiDonGiaTri == 'DON_TO_CAO') && (this.props.trangThaiTTXM == 'GIAO_TTXM')}>
            <Button type="button" className="btn-green-no-bd tt tt-print" onClick={this.props.inPhieu.bind(this, "PHIEU_GIAO_NHIEM_VU_TTXM")}>Tải quyết định giao nhiệm vụ xác minh nội dung tố cáo</Button>
          </ShowIf>
          <ShowIf condition={(this.props.loaiDonGiaTri == 'DON_KHIEU_NAI') && (this.props.trangThaiTTXM == 'GIAO_TTXM')}>
            <Button type="button" className="btn-green-no-bd tt tt-print" onClick={this.props.inPhieu.bind(this, "PHIEU_GIAO_NHIEM_VU_TTXM")}>Tải quyết định giao nhiệm vụ xác minh nội dung khiếu nại</Button>
          </ShowIf>
          <ShowIf condition={(this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && (this.props.trangThaiTTXM == 'GIAO_TTXM')}>
            <Button type="button" className="btn-green-no-bd tt tt-print" onClick={this.props.inPhieu.bind(this, "PHIEU_GIAO_NHIEM_VU_TTXM")}>Tải văn bản giao nhiệm vụ xác minh nội dung kiến nghị, phản ánh</Button>
          </ShowIf>
        </ShowIf>
        <ShowIf condition={this.props.huongXuLy == processType.xuLyDon.huongXuLy.khongDuDieuKienThuLy && (this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH')}>
          <Button type="button" className="btn-green-no-bd tt tt-print" onClick={this.props.inPhieu.bind(this, "KHONG_DU_DIEU_KIEN_THU_LY_KHIEU_NAI")}>Tải thông báo không đủ điều kiện thụ lý</Button>
        </ShowIf>
        <ShowIf condition={this.props.huongXuLy == processType.xuLyDon.huongXuLy.traDonVaHuongDan && (this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO')}>
          <Button type="button" className="btn-green-no-bd tt tt-print" onClick={this.props.inPhieu.bind(this, "HUONG_DAN")}>Tải văn bản hướng dẫn</Button>
        </ShowIf>
        <ShowIf condition={this.props.huongXuLy == processType.xuLyDon.huongXuLy.huongDanVietLaiDon && this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH'}>
          <Button type="button" className="btn-green-no-bd tt tt-print" onClick={this.props.inPhieu.bind(this, "HUONG_DAN_DON_KIEN_NGHI_PHAN_ANH")}>Tải văn bản hướng dẫn</Button>
        </ShowIf>
        <ShowIf condition={this.props.huongXuLy == processType.xuLyDon.huongXuLy.chuyenDon && (this.props.loaiDonGiaTri == 'DON_TO_CAO' ||  this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH')}>
          <Button type="button" className="btn-green-no-bd tt tt-print" onClick={this.props.inPhieu.bind(this, "CHUYEN_DON")}>Tải phiếu chuyển đơn</Button>
        </ShowIf>
        <ShowIf condition={(this.props.huongXuLy == processType.xuLyDon.huongXuLy.traDonChuyenKhongDungThamQuyen && (this.props.loaiDonGiaTri == 'DON_TO_CAO' ||  this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH')) || (this.props.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON' && this.props.loaiDonGiaTri == 'DON_KHIEU_NAI')}>
          <Button type="button" className="btn-green-no-bd tt tt-print" onClick={this.props.inPhieu.bind(this, "TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN")}>Tải phiếu trả đơn chuyển không đúng thẩm quyền</Button>
        </ShowIf>
      </div>

    );
  }
}

InPhieu.defaultProps = {
  huongXuLy: ''
}

export default InPhieu;


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-xu-ly/chuyen-vien/InPhieu.jsx